export const STUDENTS_LAYOUT = {
    GRID: 'grid',
    LIST: 'list'
}